import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.707 3.293a1 1 0 0 1 0 1.414L7.414 11H19a1 1 0 1 1 0 2H7.414l6.293 6.293a1 1 0 0 1-1.414 1.414l-8-8-.073-.082a1.004 1.004 0 0 1-.007-.008l.08.09A1.008 1.008 0 0 1 4 12.02v-.037c0-.024.002-.048.004-.071L4 12a1.008 1.008 0 0 1 .213-.617.97.97 0 0 1 .08-.09l8-8a1 1 0 0 1 1.414 0z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }